<div class="field-block field-qr-code">
  <img class="qr-code" src="assets/images/qrcode.png" />
</div>
